import {
	FETCH_RESTAURANT_AVAILABILITY_BEGIN,
	FETCH_RESTAURANT_AVAILABILITY_SUCCESS,
	FETCH_RESTAURANT_AVAILABILITY_FAILURE,
	RESET_RESTAURANT_AVAILABILITY,
} from '../actions/fetchRestaurantAvailability'

import merge from 'lodash/merge'
import { omit } from 'lodash'
import _ from 'lodash'

const initialState = {
	loading: [],
	error: []
}

export default function restaurantAvailabilityReducers(state = initialState, action) {
	switch(action.type) {
		case FETCH_RESTAURANT_AVAILABILITY_BEGIN:
			return {
				...state,
				loading: _.concat(state.loading, action.payload),
				error: _.remove(state.error, action.payload)
			}

		case FETCH_RESTAURANT_AVAILABILITY_SUCCESS:
			return {
				...state,
				loading: _.remove(state.loading, Object.keys(action.payload)),
				availability: merge({}, state.availability, action.payload),
				error: _.remove(state.error, Object.keys(action.payload))
			}

		case RESET_RESTAURANT_AVAILABILITY:
			return {
				...state,
				availability: omit(state.availability, action.payload)
			}

		case FETCH_RESTAURANT_AVAILABILITY_FAILURE:
			return {
				...state,
				loading: _.remove(state.loading, action.payload),
				error: _.concat(state.error, action.payload)
			}

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/restaurantAvailabilityReducers.js